export const UPDATE_DEMO_SCHEDULING_DATA = 'UPDATE_DEMO_SCHEDULING_DATA'
export const RESET_DEMO_SCHEDULING_DATA = 'RESET_DEMO_SCHEDULING_DATA'
export const UPDATE_DEMO_SCHEDULING_USER_DATA =
  'UPDATE_DEMO_SCHEDULING_USER_DATA'
